import { render } from "./SellBtn.vue?vue&type=template&id=230c6e80&scoped=true&ts=true"
import script from "./SellBtn.vue?vue&type=script&lang=ts"
export * from "./SellBtn.vue?vue&type=script&lang=ts"

import "./SellBtn.vue?vue&type=style&index=0&id=230c6e80&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230c6e80"]])

export default __exports__